/**
 * tracingMonitoringServiceModule监测跟踪服务
 * author Qian.qianchen 2019-06-22
 */
"use strict";
angular.module("tracingMonitoringServiceModule", ["editTrackModule"]).factory('tracingMonitoringService', ['$modal', '$q', function($modal, $q) {
    return {
        editTrack: function(trackid) {
            let defer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/realTimeClues/plannedClues/tracingMonitoring/service/editTrack/editTrack_tpl.html",
                windowClass: "edit_track_window",
                backdrop: false,
                resolve: {
                    trackId: function() {
                        return trackid;
                    },
                },
                controller: "editTrackCtrl",
            });
            modalInstance.result.then(function(result) {
                defer.resolve(result);
            });
            return defer.promise;
        }
    }
}]);